module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "password-input w-input"
  }, [(_vm.label) ? _c('label', {
    staticClass: "w-input__label",
    attrs: {
      "for": "loginpassword"
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _c('input', _vm._b({
    staticClass: "w-input__input",
    attrs: {
      "id": "loginpassword",
      "type": _vm.isVisible ? 'text' : 'password'
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input', $event.target.value)
      }
    }
  }, 'input', _vm.$attrs, false)), _c('div', {
    staticClass: "w-input__right-block"
  }, [(_vm.isVisible) ? _c('img', {
    staticClass: "icon",
    attrs: {
      "role": "button",
      "title": "Hide password",
      "src": _vm.iconInvisible
    },
    on: {
      "click": function($event) {
        _vm.isVisible = false
      }
    }
  }) : _c('img', {
    staticClass: "icon",
    attrs: {
      "role": "button",
      "title": "Show password",
      "src": _vm.iconVisible
    },
    on: {
      "click": function($event) {
        _vm.isVisible = true
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3317b7a0","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PasswordInput.vue
// module id = 593
// module chunks = 1